/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/*------------------------------------------------------------------
Import packages that are required globally
------------------------------------------------------------------*/

import Classy from '@meteora-digital/classy';
import MacyController from 'macy';
import { tns } from 'tiny-slider/src/tiny-slider';
import DomObserverController from 'domobserverjs';

/*------------------------------------------------------------------
Assign the packages to the window object
------------------------------------------------------------------*/

window.Classy = Classy;
window.MacyController = MacyController;
window.DomObserver = new DomObserverController();
window.tns = tns;
window.ThemeColours = {};

/*------------------------------------------------------------------
Global scripts - scripts required on every page
------------------------------------------------------------------*/

import 'scripts/components/region-select';
import 'scripts/components/in-view';
// import 'scripts/components/in-view-progress';
import 'scripts/components/lazy-load';
import 'scripts/elements/header';

// Access Theme Colours
const rootStyles = getComputedStyle(document.documentElement);
window.ThemeColourNames.forEach(key => {
  const variations = ['', '-contrast', '-on-contrast'];
  variations.forEach(variation => {
    const varName = `--colour-${key}${variation}`;
    window.ThemeColours[varName] = rootStyles.getPropertyValue(varName).trim();
  });
});

// Custom Form Events
[...document.querySelectorAll('.js-form form')].forEach(element => {
  element._callbacks = {};
  element._on = (event, callback) => {
    if (!event || typeof callback !== 'function') return;
    !element._callbacks[event] ? element._callbacks[event] = [callback] : element._callbacks[event].push(callback);
  };
});

// Add the src and a condition required to load the script
window.ScriptLoader = ScriptLoader({
  './components/scroll': true,
  './elements/dialog': true,
  './components/glow': document.querySelector('.js-glow'),
  './elements/mobile-menu': document.querySelector('.js-mobile-menu'),
  './elements/mega-menu': document.querySelector('.js-mega-menu'),
  './elements/selects': document.querySelector('select'),
  './elements/blob': document.querySelector('.js-blob'),
  './elements/videos': document.querySelector('[data-video]'),
  './elements/video-modals': document.querySelector('[data-video-modal]'),
  // './components/region-select': document.querySelector('.js-region-select'),
  // './components/breakpoints': document.querySelector('[data-breakpoint]'),
  './components/popout': document.querySelector('.js-popout'),
  './components/form-validation': document.querySelector('.js-form form'),
  './components/equalizer': document.querySelector('[data-equalize-watch]'),
  './components/background-takeover': document.querySelector('.js-background-takeover'),
  './blocks/blob/image-text': document.querySelector('.js-blob__image-text--blob'),
  './blocks/default/tabbed-content': document.querySelector('.js-tabbed-content'),
  './blocks/default/accordion': document.querySelector('.js-accordion'),
  './blocks/default/slider': document.querySelector('.js-slider'),
  './blocks/default/solutions': document.querySelector('.js-solutions'),
  './blocks/default/call-to-action': document.querySelector('.js-call-to-action'),
  './blocks/default/link': document.querySelector('.js-default-link'),
  './blocks/default/showcase': document.querySelector('.js-showcase'),
  './blocks/animated/solutions': document.querySelector('.js-animated-solutions'),
  './blocks/default/metrics': document.querySelector('.js-metrics'),
  './blocks/featured/slider': document.querySelector('.js-featured-slider'),
  './pages/blog': document.querySelector('.js-blog'),
  './pages/team': document.querySelector('.js-default-team'),
  './pages/contact': document.querySelector('.js-contact-page'),
  './custom-elements/google-map': document.querySelector('google-map'),
  './custom-elements/maps-link': document.querySelector('maps-link')
});

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader(imports = {}) {
  // An array of the import object keys
  const scripts = Object.keys(imports);
  // For debugging purposes only
  const components = [];
  // The index we are up to with loading scripts
  let index = -1;
  const load = () => {
    // Make sure we have a script to import
    if (index >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event
      setTimeout(() => window.dispatchEvent(new Event('scripts-loaded')), 500);
      return;
    }
    ;

    // Increment the index
    index += 1;

    // If this script is not needed, continue to the next script;
    if (!imports[scripts[index]]) {
      load();
      return;
    }
    ;

    // Otherwise continue on to load the script
    import(`${scripts[index]}`).then(() => components.push(scripts[index])).catch(error => console.warn(error)).finally(() => load());
  };
  load();
  return components;
}
window.addEventListener('scripts-loaded', () => {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
  window.ScrollLocker.unlock();
});